import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Calendar, ChevronLeft } from "lucide-react";
import { api, resolveImg } from "@/lib/api";
import SEOHead from "@/components/SEOHead";

export default function BlogDetail() {
  const { slug } = useParams();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get(`/news/${slug}`).then(r => setNews(r.data)).catch(() => setNews(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="max-w-3xl mx-auto py-16 px-4"><div className="skeleton h-96" /></div>;
  if (!news) return (
    <div className="max-w-3xl mx-auto py-24 px-4 text-center">
      <h1 className="section-heading mb-4">Статья не найдена</h1>
      <Link to="/blog" className="btn-primary-cta">К списку новостей</Link>
    </div>
  );

  return (
    <article className="bg-[var(--color-bg-primary)]" data-testid="blog-detail-page">
      <SEOHead title={news.title} description={news.excerpt} image={news.cover_url} />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <Link to="/blog" className="inline-flex items-center gap-1 font-accent text-xs uppercase tracking-wider text-[var(--color-text-secondary)] hover:text-[var(--color-primary)] mb-6">
          <ChevronLeft size={14} /> Все новости
        </Link>
        {news.cover_url && (
          <div className="aspect-[16/9] rounded-[var(--radius-lg)] overflow-hidden mb-8 border-t-2" style={{ borderColor: "var(--color-primary)" }}>
            <img src={resolveImg(news.cover_url)} alt={news.title} className="w-full h-full object-cover" />
          </div>
        )}
        <div className="flex items-center gap-2 text-sm text-[var(--color-text-secondary)] mb-3">
          <Calendar size={14} /> {new Date(news.published_at).toLocaleDateString("ru-RU", { day: "numeric", month: "long", year: "numeric" })}
        </div>
        <h1 className="font-headings font-extrabold text-3xl md:text-4xl mb-6" data-testid="news-title">{news.title}</h1>
        {news.excerpt && <p className="font-accent text-lg text-[var(--color-text-secondary)] mb-8 leading-relaxed">{news.excerpt}</p>}
        <div className="prose prose-lg max-w-none text-[var(--color-text-primary)] leading-relaxed whitespace-pre-wrap" data-testid="news-content">{news.content}</div>
      </div>
    </article>
  );
}
